export default {
  error_messages: {
    failed_to_fetch_orders:
      'Gegevens laden mislukt. Klik op het "vernieuwen"-icoon of probeer het over 1 minuut opnieuw.',
    something_went_wrong: 'Er is iets misgegaan, probeer het opnieuw.',
  },
};
